import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import styles from './index.css'

import LeavesAPI from 'api/LeavesAPI'

import Modal from 'components/Modal'
import Button from 'components/buttons/Button'
import GPSDataMap from 'components/GPSDataMap'

import TimesheetForm from 'forms/TimesheetForm'


@withRouter
export default class Timesheet extends React.Component {
  
  static propTypes = {
    match : PropTypes.object.isRequired,
  }

  state = {
    showGPSModal: false
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { history } = this.props
    const { id } = this.props.match.params
    return (
      <div className={styles.Page}>
        <TimesheetForm 
          id={id}
          onViewGPSDataClick={({sessions}) => {
            this.setState({ showGPSModal: true, sessions })
          }}
          />

        <Modal open={this.state.showGPSModal} style={{width: 'unset'}}>
          { this.state.showGPSModal && <GPSDataMap sessions={this.state.sessions}/> }
          <br/><br/>
          <Button onClick={() => this.setState({ showGPSModal: false, sessions: null })}>
            Close 
          </Button>
        </Modal>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Timesheet/index.jsx